import { render } from "./order.vue?vue&type=template&id=7120d307&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=7120d307&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7120d307"

export default script